export default "__VITE_ASSET__oh5TW1JH__"